export enum DisplayMode {
  default = 'default',
  select = 'select',
  multiselect = 'multiselect',
}
